import { TranslationsState }       from '../../reduxTypes';
import { TranslationsErrorAction } from './TranslationsActions';
import { Reducer, Action }         from 'redux';
import ActionTypes                 from '../../ActionTypes';

export const defaultState: TranslationsState = {
    loading: false
};

const TranslationsReducer: Reducer<TranslationsState> = (state: TranslationsState = defaultState, action: Action): TranslationsState => {
    switch (action.type) {
        case ActionTypes.TRANSLATIONS_LOADING:
            return {
                ...state,
                loading: true
            };

        case ActionTypes.TRANSLATIONS_LOADED:
            return {
                ...state,
                loading: false,
            };

        case ActionTypes.TRANSLATIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: (action as TranslationsErrorAction).error
            };

        default:
            return state;
    }
};

export default TranslationsReducer;



// WEBPACK FOOTER //
// ./src/sections/Translations/TranslationsReducer.ts